module.exports = __webpack_public_path__ + "img/Error free.39edf5aa.svg";